import keyMirror from 'keymirror'

export const contactInfoMap = {
  id: ['id'],
  vendorId: ['id'],
  name: ['name'],
  addressLine1: ['users', 0, 'contacts', 'ADDRESS', 0, 'addressLine1'],
  addressLine2: ['users', 0, 'contacts', 'ADDRESS', 0, 'addressLine2'],
  addressLine3: ['users', 0, 'contacts', 'ADDRESS', 0, 'addressLine3'],
  addressLine4: ['users', 0, 'contacts', 'ADDRESS', 0, 'addressLine4'],
  phoneNumber: ['users', 0, 'contacts', 'PHONE_NUMBER', 1],
  contactAdmin: ['users', 0, 'contacts', 'NAME', 0],
  email: ['users', 0, 'contacts', 'EMAIL', 0],
  contactPhone: ['users', 0, 'contacts', 'PHONE_NUMBER', 0],
  username: ['users', 0, 'username'],
  invitedAt: ['users', 0, 'invitedAt'],
}

export const contactTypes = keyMirror({
  EMAIL: null,
  ADDRESS: null,
  NAME: null,
  PHONE_NUMBER: null,
  PROFILE_EMAIL: null,
  PROFILE_PHONE_NUMBER: null,
})
